<template>
  <q-btn
    v-if="showAddButton"
    class="col-auto row items-center"
    style="max-width: 108px; min-width: 50px;"
    :style="{ width: $q.screen.lt.lg ? undefined : '100%' }"
    :label="addUnavailable ? $t('pages.activitySelectTickets.labels.unavailable')
      : $t('pages.activitySelectTickets.labels.add')"
    :text-color="addUnavailable ? 'responsive-grey-5' : 'responsive-grey-9'"
    :color="!addUnavailable && !$register ? 'responsive-grey-2' : undefined"
    :flat="addUnavailable"
    :disable="addUnavailable"
    data-test-id="select-tickets-add-button"
    v-bind="$attrs"
    @click.stop="$emit('add')"
  >
    <slot name="tooltip" />
  </q-btn>
  <q-item-label
    v-else-if="showAddAndRemoveButtons"
    class="row justify-around items-center"
  >
    <q-btn
      class="col-auto"
      style="min-width: 36px;"
      :icon="quantity > 1 ? 'fal fa-minus' : 'fal fa-trash-can'"
      dense
      :color="!$register ? 'responsive-grey-2' : undefined"
      :text-color="decrementDisabled ? 'responsive-grey-5' : 'responsive-grey-8'"
      :disable="decrementDisabled"
      v-bind="$attrs"
      @click.stop="$emit('decrement')"
    >
      <slot name="decrement-tooltip" />
    </q-btn>
    <div
      class="col-auto"
      :class="$q.screen.lt.sm ? 'text-body1 text-bold q-px-xs' : 'text-h5 q-px-md'"
      style="line-height:2rem"
      data-test-id="select-tickets-count"
    >
      {{ itemCountDescription }}
    </div>
    <q-btn
      class="col-auto"
      icon="fal fa-plus"
      style="min-width: 36px;"
      dense
      :color="!$register ? 'responsive-grey-2' : undefined"
      :text-color="incrementDisabled ? 'responsive-grey-5' : 'responsive-grey-8'"
      :disable="incrementDisabled"
      v-bind="$attrs"
      @click.stop="$emit('increment')"
    >
      <slot name="increment-tooltip" />
    </q-btn>
  </q-item-label>
  <q-item-label
    v-else
    class="d-flex justify-around"
  >
    <q-btn
      class="col-auto q-px-xs"
      icon="fal fa-trash-can"
      color="responsive-grey-2"
      text-color="responsive"
      round
      v-bind="$attrs"
      @click.stop="$emit('decrement')"
    />

    <q-chip
      color="white"
      flat
      square
      :size="$q.screen.lt.sm ? 'md' : 'lg'"
    >
      1
    </q-chip>
  </q-item-label>
</template>

<script>
export default {
  name: 'AddAndRemoveButtonSet',
  inject: ['order', 'checkoutData'],
  props: {
    showAddButton: {
      type: Boolean,
      required: false,
      default: true
    },
    showAddAndRemoveButtons: {
      type: Boolean,
      required: false,
      default: true
    },
    quantity: {
      type: Number,
      required: false,
      default: 0
    },
    itemCountDescription: {
      type: String,
      required: false,
      default: ''
    },
    addUnavailable: {
      type: Boolean,
      required: false,
      default: false
    },
    incrementDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    decrementDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['decrement', 'increment', 'add']
}
</script>
